import ContentfulRichText from '../domains/contentful/ContentfulRichText'
import ContentfulSite from '../domains/contentful/ContentfulSite'

export const VALENTINE_DAY_CONF_MAP_UTC: Record<string, string> = {
  '1': '2024-01-13 08:00:00Z',
  '2': '2024-01-29 08:00:00Z',
  '3': '2024-02-01 08:00:00Z',
  '4': '2024-02-02 08:00:00Z',
  '5': '2024-02-07 08:00:00Z',
}

const PHASE_3_BANNER_VALENTINE_DESKTOP: ContentfulRichText[] = [
  {
    id: '37b64887-27fb-5f3d-8954-75c2fb8f2454',
    commonClassNames: ['background-color--cantalope', 'color--black'],
    desktopClassNames: null,
    mobileClassNames: null,
    dynamicValueClassesMobile: null,
    baseDynamicValueClasses: null,
    startFrom: '2024-02-02',
    endOn: '2024-02-05',
    content: {
      raw: '{"nodeType":"document","data":{},"content":[{"nodeType":"paragraph","data":{},"content":[{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"3nr1VT96TaW3nEMgMSqeR4","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":" left to get it before V-day.\\n","marks":[],"data":{}}]}]}',
      references: [
        {
          baseDynamicValueClasses: ['type--countdown', 'end-time-epoch--1707206400000'],
          content: {
            raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"{{DD}}","nodeType":"text"},{"data":{},"marks":[],"value":" days : ","nodeType":"text"},{"data":{},"marks":[],"value":"{{HH}}","nodeType":"text"},{"data":{},"marks":[],"value":" hours : ","nodeType":"text"},{"data":{},"marks":[],"value":"{{MM}}","nodeType":"text"},{"data":{},"marks":[],"value":" min","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}',
          },
          contentful_id: '3nr1VT96TaW3nEMgMSqeR4',
        },
      ],
    },
  },
]

const PHASE_3_BANNER_VALENTINE_MOBILE: ContentfulRichText[] = [
  {
    id: '37b64887-27fb-5f3d-8954-75c2fb8f2454',
    commonClassNames: ['background-color--cantalope', 'color--black'],
    mobileClassNames: null,
    dynamicValueClassesMobile: null,
    baseDynamicValueClasses: null,
    desktopClassNames: null,
    startFrom: '2024-02-02',
    endOn: '2024-02-05',
    content: {
      raw: '{"nodeType":"document","data":{},"content":[{"nodeType":"paragraph","data":{},"content":[{"nodeType":"text","value":"","marks":[],"data":{}},{"nodeType":"embedded-entry-inline","data":{"target":{"sys":{"id":"3nr1VT96TaW3nEMgMSqeR4","type":"Link","linkType":"Entry"}}},"content":[]},{"nodeType":"text","value":" left to get it before V-day.\\n","marks":[],"data":{}}]}]}',
      references: [
        {
          baseDynamicValueClasses: ['type--countdown', 'end-time-epoch--1707206400000'],
          content: {
            raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"{{DD}}","nodeType":"text"},{"data":{},"marks":[],"value":" days : ","nodeType":"text"},{"data":{},"marks":[],"value":"{{HH}}","nodeType":"text"},{"data":{},"marks":[],"value":" hours : ","nodeType":"text"},{"data":{},"marks":[],"value":"{{MM}}","nodeType":"text"},{"data":{},"marks":[],"value":" min","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}',
          },
          contentful_id: '3nr1VT96TaW3nEMgMSqeR4',
        },
      ],
    },
  },
]

export const getModifiedSiteDataForValentine = (
  siteData: ContentfulSite | null | undefined,
): ContentfulSite | null | undefined => {
  if (!siteData) {
    return siteData
  }

  const updatedSiteData = { ...siteData }
  updatedSiteData.announcementBannersDesktop = PHASE_3_BANNER_VALENTINE_DESKTOP
  updatedSiteData.announcementBannersMobile = PHASE_3_BANNER_VALENTINE_MOBILE
  return updatedSiteData
}

export const getFormattedValentineDate = (date?: string) => {
  return date?.substring(5).replace('-', '/')
}

export const isValentinePhase4 = (currentDateTimeInUTC: number) => {
  return (
    currentDateTimeInUTC > Date.parse(VALENTINE_DAY_CONF_MAP_UTC['4']) &&
    currentDateTimeInUTC < Date.parse(VALENTINE_DAY_CONF_MAP_UTC['5'])
  )
}

export const isValentinePhase2orHigher = (currentDateTimeInUTC: number) => {
  return (
    currentDateTimeInUTC > Date.parse(VALENTINE_DAY_CONF_MAP_UTC['2']) &&
    currentDateTimeInUTC < Date.parse(VALENTINE_DAY_CONF_MAP_UTC['5'])
  )
}
